import { BrowserRouting } from '@aipb/browser/shared/routing';
import { NibbleAction } from '@aipb/personal-content/shared/model';
import { openUrl } from '@aipb/util/routing';
import { NibbleActionHandler } from '../nibble-action.handler';

export class Document3ifNibbleActionHandler implements NibbleActionHandler {
  constructor(private browserRouting: BrowserRouting) {}

  handle(nibbleAction: NibbleAction) {
    const application = nibbleAction.application;
    const nibbleCut = nibbleAction.nibbleCut;
    const type = nibbleCut.nibble.type;
    const serviceValue = nibbleCut.cut.serviceValue;

    if (application === 'browser') {
      if (type === 'DOC3IF') {
        this.browserRouting.galleryDefault(serviceValue);
      }
    } else {
      if (type === 'DOC3IF') {
        const url = this.browserRouting.galleryDefaultAbsUrl(serviceValue);
        openUrl(url);
      }
    }
  }

  getUrl(nibbleAction: NibbleAction): string {
    const serviceValue = nibbleAction.nibbleCut.cut.serviceValue;
    return this.browserRouting.galleryDefaultAbsUrl(serviceValue);
  }

  useResolver(): boolean {
    return true;
  }
}
